import { request } from '@langlois/request';

export async function getByClubId ({ commit }, clubId) {
	commit(`setMembers`, []);

	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/club/${clubId}/team`);

		const response = await request.get(url);

		if (!response.ok || response.status === 204) return;

		const members = await response.json();

		commit(`setMembers`, members);
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the club's team members.`,
			type: `warning`
		}, { root: true });
	}
}
